import { render } from 'react-dom';
import Chrome from 'scripts/components/Chrome';
import TopMedals from 'scripts/components/TopMedals';

render(
	<Chrome>
		<TopMedals />
	</Chrome>,
	document.getElementById('pyeongchang2018TopMedals')
);



// WEBPACK FOOTER //
// ./scripts/bootstrap/topMedals.es6